import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";

export default function Remove(props) {
  const token = useSelector((state) => state.auth.token);
  const [isLoading, setIsLoading] = useState(false);
  const { onHide, show, id, logId ,onLogRows,} = props;
  
  const onDeleteUser = (e) => {
    e.preventDefault();
    setIsLoading(true)
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}card/user/${id}?cardId=${logId}`,
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((res) => {
        setIsLoading(false)

        onLogRows();
        onHide();
      })
      .catch((err) => {
      });
  };

  return (
    <Modal show={show} onHide={onHide} aria-labelledby="delete" centered
      size="sm"
    >
      <form onSubmit={onDeleteUser}>
        <Modal.Header closeButton>
          <Modal.Title id="delete">Sil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">Silməyinizə əminsiniz?</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Ləğv
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Sil</span>
            {isLoading && (
              <span className="ml-3 spinner spinner-white"></span>
            )}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
